import ClassNames from 'classnames'
import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../core/i18n'
import { IJsonResponse } from '../../../core/JsonApiSerializer'
import { postService } from '../../../core/services'
import * as constants from '../../../static/constants'
import SvgIcon from 'components/atoms/SvgIcon'

import { DateFilter, GuestFilter, PriceFilter, TypeFilter } from '../../atoms'

import { FlashMessage } from '../../organisms'

interface IWindow {
  flashMessages: FlashMessage
  location: any
}

declare var window: IWindow

interface IProps {
  categories: IJsonResponse
  areas: IJsonResponse
  tags: IJsonResponse
  languages: IJsonResponse
  handleOnFilterSubmit(params: any): void
}

const POST_TYPES = [
  {
    id: 'private',
    name: 'Private',
  },
  {
    id: 'group',
    name: 'Group',
  },
]

const ENTER_KEYCODE = 13

export const SearchHeader: React.FC<IProps> = props => {
  const [isFilterPanelOpen, setIsFilterPanelOpen] = React.useState(false)
  const { data: tags } = postService.getDataFromJson(props.tags)
  const { data: areas } = postService.getDataFromJson(props.areas)
  const { data: categories } = postService.getDataFromJson(props.categories)
  const { data: languages } = postService.getDataFromJson(props.languages)
  const urlParams = new URLSearchParams(window.location.search)
  const defaultKeywords = urlParams.get('keywords') || ''
  const onSearchHandler = async event => {
    const currentUrlParams = new URLSearchParams(window.location.search)

    if (event.target.value) {
      currentUrlParams.set(event.target.name, event.target.value)
    } else {
      currentUrlParams.delete(event.target.name)
    }

    location.href = `posts?${currentUrlParams.toString()}`
  }

  const onKeyDownHandler = event => {
    if (event.keyCode && event.keyCode === ENTER_KEYCODE) {
      onSearchHandler(event)
    }
  }

  return (
    <SearchHeaderWrapper className={ClassNames('SearchHeader', { isFilterPanelOpen })}>
      <Search className="Search">
        <div className="Search_Input _keywords">
          <input
            name="keywords"
            type="text"
            // placeholder={I18n.t('generic.keyword_in_registered_posts')}
            defaultValue={defaultKeywords}
            onBlur={onSearchHandler}
            onKeyDown={onKeyDownHandler}
          />
          <SvgIcon name="search" className="icon" ariaHidden={true} role="presentation" />
        </div>
      </Search>
      <FilterList>
        <TypeFilter
          name={I18n.t('generic.area')}
          field="area_ids"
          setIsFilterPanelOpen={setIsFilterPanelOpen}
          handleOnSubmit={props.handleOnFilterSubmit}
          types={areas}
        />
        <DateFilter
          name={I18n.t('date')}
          field="date"
          setIsFilterPanelOpen={setIsFilterPanelOpen}
          handleOnSubmit={props.handleOnFilterSubmit}
        />
        <GuestFilter
          name={I18n.t('generic.guest')}
          field="guests"
          setIsFilterPanelOpen={setIsFilterPanelOpen}
          handleOnSubmit={props.handleOnFilterSubmit}
        />
        {constants.PAYMENT_REQUIRED && (
          <PriceFilter
            name={I18n.t('generic.price')}
            field="price"
            setIsFilterPanelOpen={setIsFilterPanelOpen}
            handleOnSubmit={props.handleOnFilterSubmit}
          />
        )}
        <TypeFilter
          name={I18n.t('generic.type')}
          field="post_types"
          setIsFilterPanelOpen={setIsFilterPanelOpen}
          handleOnSubmit={props.handleOnFilterSubmit}
          types={POST_TYPES}
        />
        <TypeFilter
          name={I18n.t('generic.tag')}
          field="tag_ids"
          setIsFilterPanelOpen={setIsFilterPanelOpen}
          handleOnSubmit={props.handleOnFilterSubmit}
          types={tags}
        />
        <TypeFilter
          name={I18n.t('generic.category')}
          field="category_ids"
          setIsFilterPanelOpen={setIsFilterPanelOpen}
          handleOnSubmit={props.handleOnFilterSubmit}
          types={categories}
        />
        <TypeFilter
          name={I18n.t('post.language')}
          field="language_ids"
          setIsFilterPanelOpen={setIsFilterPanelOpen}
          handleOnSubmit={props.handleOnFilterSubmit}
          types={languages}
        />
      </FilterList>
    </SearchHeaderWrapper>
  )
}

const SearchHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column
  border-bottom: none;
  @media (max-width: ${constants.BREAKPOINT_DESKTOP}px) {
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    ::-webkit-scrollbar {
      display: none;
    }
  }
  @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
    height: auto;
    padding: 6px 12px;
  }
  &.isFilterPanelOpen {
    overflow: visible;
  }
`

const FilterList = styled.div`
  margin-right: 800px;
  margin-bottom: 10px;
  white-space: nowrap;
  > div {
    display: inline-block;
    margin-right: 5px;
  }
`
const Search = styled.div`
  display: flex;
  position: relative;
  width: 360px;
  margin: 10px 10px 10px 0;
  .Search_Input {
    position: relative;
    margin-bottom: 1em;

    > .icon {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 10px;
      margin: auto;
      width: 24px;
      height: 24px;
    }
    > input {
      display: block;
      width: 100%;
      padding: 8px 12px 8px 36px;
      border: solid 1px ${constants.COLORS.divider};
      border-radius: 20px;
      font-size: 15px;
      transition: border 0.2s ease;
      outline: none;
      background: none;
      background: #f8f8f8;
      box-sizing: border-box;
      &::placeholder {
        color: ${constants.COLORS.subText};
        font-size: 13px;
      }
      &:focus {
        border: solid 1px ${constants.COLORS.primary};
      }
    }
  }
`
